import React from "react";
import PropTypes from "prop-types";
import {chipSx, paperSx} from "./styles";
import {Chip, Paper} from "@mui/material";

function ProfessionChipsArea(props) {

    const handleDelete = (profession) => () => {
        props.handleDelete(profession)
    };

    return (
        <Paper component="ul" sx={paperSx}>
            {props.professions.map((profession) => {
                return (
                    <li key={profession.id}>
                        <Chip
                            label={profession.title}
                            onDelete={props.areaDisabled ? undefined : handleDelete(profession)}
                            sx={chipSx}
                        />
                    </li>
                )
            })}
        </Paper>
    );
}

ProfessionChipsArea.propTypes = {
    professions: PropTypes.array.isRequired,
    handleDelete: PropTypes.func,
    areaDisabled: PropTypes.bool.isRequired
};

export default ProfessionChipsArea;